import { RootState } from 'theSource/app/store';

export const selectIsAuthenticated = (state: RootState) =>
  state.theSource.authentication.isAuthenticated;

export const selectRedirectLink = (state: RootState) =>
  state.theSource.authentication.redirectLink;

export const selectSourceEnabled = (state: RootState) =>
  state.theSource.authentication.sourceEnabled;

export const selectLumosEnabled = (state: RootState) =>
  state.theSource.authentication.lumosEnabled;

export const selectHomeEnabled = (state: RootState) =>
  state.theSource.authentication.homeEnabled;

export const selectOldEnrollmentUrl = (state: RootState) =>
  state.theSource.authentication.oldEnrollmentUrl;

export const selectMfaEnabled = (state: RootState) =>
  state.theSource.authentication.mfaEnabled;

export const selectMfaRequired = (state: RootState) =>
  state.theSource.authentication.mfaRequired;

export const selectMfaConfigured = (state: RootState) =>
  state.theSource.authentication.mfaConfigured;
